module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shift.shift_times.length > 0 || _vm.shift.can_add) ? _c('div', {
    staticClass: "presence-list"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.shift.shift_type))]), _vm._v(" (" + _vm._s(_vm._f("moment")([_vm.shift.start, "HH:mm:ss"], 'HH:mm')) + " Uhr)")]), _vm._l((_vm.shift.shift_times), function(entry) {
    return _c('presence-entry', {
      key: entry.id,
      attrs: {
        "shift-time": entry,
        "user": _vm.user
      },
      on: {
        "refresh": function($event) {
          return _vm.$emit('refresh')
        }
      }
    })
  }), (_vm.shift.can_add && _vm.user.can_record_shift_times) ? _c('vue-autosuggest', {
    ref: "addEmployee",
    staticClass: "addButton",
    class: {
      'confirmationPending': _vm.selected
    },
    attrs: {
      "suggestions": _vm.filteredOptions,
      "input-props": _vm.inputProps,
      "getSuggestionValue": _vm.getValue
    },
    on: {
      "input": _vm.onInputChange,
      "selected": _vm.onSelected,
      "focus": function($event) {
        return _vm.getEmployeeList()
      },
      "click": _vm.clickHandler,
      "closed": function($event) {
        return _vm.clearLetters()
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var suggestion = ref.suggestion;

        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.bolden(_vm.query, suggestion.item.short_name))
          }
        })]
      }
    }], null, false, 2850676057),
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }) : _vm._e(), (_vm.selected) ? _c('span', [_c('button', {
    on: {
      "click": function($event) {
        return _vm.confirmSelection()
      }
    }
  }, [_vm._v("JA")]), _c('button', {
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("Abbrechen")])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d81f1cf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PresenceList.vue
// module id = 1081
// module chunks = 1